import styled from 'styled-components';
import { theme } from '../layout/theme';
import { size } from '../layout/helpers';

export const EfiBox = styled.div`
  margin-left: ${size(1)};
  font-size: ${size(2)};

  ${theme.screens.Md} {
    margin-left: 0;
    font-size: ${size(2.5)};
  }
`;
